import React, { FunctionComponent, useState } from 'react';
import { Header, Main, SiteMetadata, Layout, Footer } from '..';

import styles from './Page.module.scss';

interface PageProps {
  className?: string;
  location?: object;
}

const Page: FunctionComponent<PageProps> = ({
  className,
  children,
  location,
}) => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Layout className={className}>
      <SiteMetadata location={location} />
      <Header navOpen={navOpen} setNavOpen={setNavOpen} location={location} />
      <div className={navOpen ? styles.hide : ''}>
        <Main>{children}</Main>
        <Footer />
      </div>
    </Layout>
  );
};

export default Page;
